'use client'
import { SanityImageSource } from '@sanity/asset-utils'
import Img from 'next/image'
import { useNextSanityImage } from 'next-sanity-image'

import { client } from '@/lib/util/client'

export default function ImageComponent({
  className,
  value,
}: {
  className: string
  value: SanityImageSource
}) {
  const imageProps = useNextSanityImage(client, value)

  return (
    <Img
      {...imageProps}
      loading="lazy"
      alt="Abstract visualisation of nature based solutions in a Nordic context"
      className={className}
    />
  )
}
